"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const faqs = [{
  question: "מהן שעות הזמינות של מטפל סיעודי בתל אביב?",
  answer: <>
        אנו מבינים שצרכים סיעודיים אינם מוגבלים לשעות העבודה הרגילות. לכן, אנו מספקים שירותי סיעוד בתל אביב בזמינות של 24/7, כולל סופי שבוע וחגים. ניתן להזמין{" "}
        <Link to="/" className="text-primary font-semibold hover:underline">מטפל סיעודי בבית</Link>{" "}
        למשמרות יום, משמרות לילה או לליווי צמוד מסביב לשעון. המוקד שלנו זמין עבורכם בכל עת למתן מענה מיידי ושיבוץ מטפל מקצועי תוך שעות ספורות מרגע הפנייה, כדי להבטיח שקט נפשי למשפחה.
      </>
}, {
  question: "מהן העלויות הממוצעות לשירותי סיעוד באזור תל אביב?",
  answer: <>
        התמחור בתל אביב נקבע בהתאם למספר גורמים: היקף השעות הנדרש, רמת המורכבות של הטיפול (סיעוד בסיסי מול טיפול מורכב) וסוג ההתקשרות. אנו מציעים תעריפים תחרותיים ושקיפות מלאה ללא אותיות קטנות. חשוב לציין כי ניתן לקבל החזרים דרך קופות החולים, ביטוחים פרטיים או גמלת סיעוד של הביטוח הלאומי, ואנו נשמח לסייע לכם במיצוי הזכויות הכספיות המגיעות לכם. למידע נוסף, מומלץ לקרוא ב-
        <Link to="/BlogPage" className="text-primary font-semibold hover:underline">בלוג המקצועי</Link>{" "}
        שלנו על עלויות וזכויות.
      </>
}, {
  question: "אילו הכשרות וכישורים יש למטפלים שלכם?",
  answer: <>
        כל המטפלים בצוות שלנו עוברים תהליך מיון קפדני הכולל בדיקת רקע, אימות המלצות והצגת תעודות הכשרה רלוונטיות. המטפלים שלנו מוסמכים במתן עזרה ראשונה, ניידות בטוחה, היגיינה אישית וניהול תרופות. מעבר למקצועיות, אנו שמים דגש רב על אינטליגנציה רגשית, סבלנות ויכולת תקשורת גבוהה, כדי להבטיח שהמטפל יהיה לא רק איש מקצוע אלא גם בן לוויה תומך. אנו מספקים שירות זה גם בערים נוספות כמו{" "}
        <Link to="#" className="text-primary font-semibold hover:underline">מטפל סיעודי בירושלים</Link>.
      </>
}, {
  question: "כיצד אתם פועלים במקרה של מצב חירום רפואי?",
  answer: <>
        בטיחות המטופל היא בראש סדר העדיפויות שלנו. כל מטפל מתודרך לגבי פרוטוקול חירום ספציפי הכולל יצירת קשר מיידי עם מד"א, עדכון המשפחה ודיווח למוקד הניהול שלנו. המטפלים שלנו מאומנים לזהות סימני מצוקה מוקדמים ולפעול בקור רוח. בנוסף, אנו מחזיקים בתיק רפואי מעודכן של המטופל הכולל רשימת תרופות ואלרגיות, הזמין למטפל ולצוותי הרפואה בכל רגע נתון. השירות זמין גם עבור{" "}
        <Link to="#" className="text-primary font-semibold hover:underline">מטפל סיעודי בחיפה</Link>.
      </>
}, {
  question: "האם השירות מכוסה על ידי ביטוחים פרטיים או קופות חולים?",
  answer: <>
        בהחלט. אנו עובדים מול מרבית חברות הביטוח הפרטיות וקופות החולים. בהתאם לפוליסה שברשותכם, תוכלו לקבל החזרים משמעותיים על שירותי סיעוד פרטיים, ליווי לאחר ניתוח או השגחה בבית החולים. צוות המשרד שלנו מנוסה מאוד בהגשת הטפסים הנדרשים ויעניק לכם ליווי צמוד כדי להבטיח שתקבלו את המקסימום המגיע לכם מהגופים המבטחים. ניתן לראות את מגוון ה-
        <Link to="/ServicesCitiesArticlesPage" className="text-primary font-semibold hover:underline">שירותים שלנו</Link>{" "}
        הזמינים למימוש.
      </>
}, {
  question: "מה הניסיון שלכם בעבודה עם קשישים בתל אביב?",
  answer: <>
        אנו פועלים בתל אביב מזה שנים רבות ומכירים לעומק את הצרכים הייחודיים של אוכלוסיית הגיל השלישי בעיר. יש לנו ניסיון עשיר בליווי קשישים המתגוררים בדיור מוגן, בבתים פרטיים או במהלך אשפוזים בבתי החולים בעיר (כמו איכילוב). המטפלים שלנו מיומנים בהתמודדות עם דמנציה, אלצהיימר, שיקום לאחר נפילות וליווי חברתי המפיג את תחושת הבדידות העירונית. אנו מציעים שירות דומה גם עבור{" "}
        <Link to="#" className="text-primary font-semibold hover:underline">מטפל סיעודי ברמת גן</Link>.
      </>
}, {
  question: "תוך כמה זמן ניתן לקבל מטפל מרגע הפנייה?",
  answer: <>
        אנו מתחייבים למתן פתרון מהיר במיוחד. באזור תל אביב והמרכז, אנו מסוגלים לשבץ מטפל מתאים תוך פחות מ-5 שעות מרגע אישור הבקשה. אנו מחזיקים מאגר זמין של אנשי מקצוע איכותיים המוכנים ליציאה מיידית, מתוך הבנה שצורך סיעודי יכול להתעורר בפתאומיות ודורש מענה ללא דיחוי כדי לשמור על רצף טיפולי ובטיחות המטופל. לכל שאלה נוספת, ניתן{" "}
        <Link to="/ContactPage" className="text-primary font-semibold hover:underline">ליצור איתנו קשר</Link>{" "}
        בכל עת.
      </>
}];
export default function FaqAccordion() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="260461" id="שאלות-נפוצות-מטפל-סיעודי-בתל-אביב" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div ref={ref} className={`flex flex-col items-center text-center space-y-4 mb-12 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold tracking-tight text-foreground">
            שאלות נפוצות על שירותי סיעוד בתל אביב
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl font-default">
            ריכזנו עבורכם את כל המידע החשוב בנוגע להזמנת מטפל סיעודי, עלויות, זכויות וזמינות השירות בעיר.
          </p>
        </div>

        <div className={`transition-all duration-700 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border rounded-lg px-6 bg-card shadow-md">
                <AccordionTrigger className="text-base md:text-lg font-default font-semibold hover:no-underline py-6 text-primary">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-default text-base leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}